<template>
  <div class="alert alert-success d-flex justify-content-between">
    <div class="text-dark h4 fw-bold">Export User Data</div>
    <button
      class="btn btn-success fw-bold"
      @click="exportToCSV(entries, filename)"
    >
      Download CSV
    </button>
  </div>
</template>

<script>
import config from "@/data/config";

export default {
  name: "AdminExport",
  props: {
    entries: Array
  },
  methods: {
    objectToCSVRow(dataObject) {
      console.log(dataObject);

      let dataArray = dataObject.map((datum) => {
        let value = datum === null ? "" : datum.toString();
        value = value.replace(/"/g, '""');
        value = value.replaceAll(",", ";");
        return value;
      });

      return dataArray.join(",") + "\r\n";
    },
    exportToCSV(arrayOfObjects, filename) {
      arrayOfObjects = arrayOfObjects.map((object) => {
        return {
          fullname: object.fullname,
          value: JSON.stringify(object.value),
          lastUpdated: object.tsUpdatedLabel
        };
      });
      if (!arrayOfObjects.length) {
        console.log("Cannot export. Invalid array", arrayOfObjects);
        return;
      }
      console.log("Exporting", filename);

      let csvContent = "data:text/csv;charset=utf-8,";

      const keys = Object.keys(arrayOfObjects[0]);
      /* Headers */
      csvContent += this.objectToCSVRow(keys);
      /* Content */

      arrayOfObjects.map((item) => {
        csvContent += this.objectToCSVRow(Object.values(item));
      });
      console.log(csvContent);

      const encodedUri = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", `${filename}.csv`);
      document.body.appendChild(link); // Required for FF
      link.click();
      document.body.removeChild(link);
    }
  },
  computed: {
    filename() {
      const formatString = (value) => value.toLowerCase().replace(/[\s-]/, "");
      // Name file by class abbreviation and app title
      return `${formatString(config.meta.course)}-${formatString(
        config.meta.title
      )}-user-data`;
    }
  }
};
</script>
